import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import { apiMetrics } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { RecalculateMetricsApprovalModal } from 'components/modals'
import styles from './recalculate-metrics.styl'
import { connect } from 'react-redux'


@apiMetrics()
@connect(
  state => ({
    metrics: state.api.metrics
  }), {}
)
@form({
  form: 'formRecalculateMetrics',
  disableHook: true
})
class RecalculateMetrics extends Component {
  static propTypes = {
    modal: PropTypes.object,
    notification: PropTypes.func,
    logError: PropTypes.func,
    recalculateOrganizationMetrics: PropTypes.func,
    metrics: PropTypes.object
  }

  handleSubmit(event) {
    this.props.modal('recalculate-metrics-approval-modal')
    event.preventDefault()
  }

  handleOnApprove() {
    this.props.recalculateOrganizationMetrics({ recalculateAll: true }).then(() => {
      this.props.modal(null)
    }).catch(this.handleError)
  }

  handleError = err => {
    this.props.logError(err)
    this.props.modal(null)
    if (err && err.body) {
      console.debug('error', err.body && err.body.userMessage)
      this.props.notification(err.body.userMessage || 'Error', 'error')
    }
  }

  render() {
    const { metrics: { isLoading } = {} } = this.props

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
              <Form>
                <Title h1>
                  <FormattedMessage
                    id="moduleTitle.recalculate_metrics"
                    defaultMessage="Recalculate Metrics"
                  />
                </Title>

                <Button onClick={event => this.handleSubmit(event)}>
                  <FormattedMessage id="button.recalculate" defaultMessage="Recalculate" />
                </Button>
              </Form>
              <RecalculateMetricsApprovalModal
                modalId="recalculate-metrics-approval-modal"
                isLoading={isLoading}
                onApprove={() => this.handleOnApprove()}
              />
            </Row>
          </div>
        </Module>
      </div>
    )
  }
}

export default RecalculateMetrics
